import { Injectable, inject } from '@angular/core';
import { AclEntry } from '@app/common';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root',
})
export class EnvironmentAclEntryData {

  private _api = inject(FsApi);

  public create(environmentId: number, data: AclEntry = { id: null }) {
    return data;
  }

  public save(environmentId: number, data): Observable<any> {
    if (data.id) {
      return this.put(environmentId, data);
    }

    return this.post(environmentId, data);
  }

  public get(environmentId: number, id, data = {}): Observable<any> {
    return this._api.get(`environments/${environmentId}/acl/entries/${id}`, data, { key: 'aclEntry' });
  }

  public gets(environmentId: number, data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', `environments/${environmentId}/acl/entries`, data, { key: 'aclEntries', ...config });
  }

  public put(environmentId: number, data, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`environments/${environmentId}/acl/entries/${data.id}`, data, { key: 'aclEntry', ...config });
  }

  public post(environmentId: number, data): Observable<any> {
    return this._api.post(`environments/${environmentId}/acl/entries`, data, { key: 'aclEntry' });
  }

  public delete(environmentId: number, data): Observable<any> {
    return this._api.delete(`environments/${environmentId}/acl/entries`, data, { key: 'aclEntry' });
  }

  public bulk(environmentId: number, data): Observable<any> {
    return this._api.post(`environments/${environmentId}/acl/entries/bulk`, data);
  }

  public clear(environmentId: number, data): Observable<any> {
    return this._api.post(`environments/${environmentId}/acl/entries/clear`, data);
  }

}
